import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import AxiosInstance from '../Axios';
import { CListGroup, CListGroupItem, CButton } from '@coreui/react';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';

// Додавання сторінок до faq
const FaqsPages = (props) => {
   // console.log("props", props);
   // props.faq_id - id-faq

   // Сторінки, які додані до faq
   const [pagesItem, setPagesItem] = useState([]);
   // Сторінки, які додані до faq, записані у форматі PUT (`api/faqs/id`) для відправлення
   const [oldPages, setOldPages] = useState([]);
   // Вибрана сторінка з пошуку
   const [selectedOption, setSelectedOption] = useState(null);
   // Текст для popup
   const popupTextPutSuccess = "Сторінку додано";
   const popupTextDeleteSuccess = "Сторінку видалено";
   const popupTextWarning = "Вибрана сторінка вже належить до даного faq";

   let i = 0;
   const handleChange = (selectedOption) => {
      setSelectedOption(selectedOption);
   };

   // Завантаження всіх сторінок для вибору з випадаючого списку
   const loadOptions = async (inputValue) => {
      return await AxiosInstance.get(`/pages?name=${inputValue}`, { headers: { 'accept': 'application/json' } }).then((response) => {
         return response.data.map((result) => ({
            label: result.name,
            value: result.id,
         }));
      });
   };

   // Запит за категоріями, які вже додані до faq
   // const getParent = async () => {
   //    AxiosInstance.get(`/pages?faqs.id=${props.faq_id}`, { headers: { 'accept': 'application/json' } }).then((response) => {
   //       // console.log("response get faqs", response);
   //       setPagesItem(response.data)
   //    });
   // }

   //Запит на оновлення faq
   const getParent = async () => {
      AxiosInstance.get(`/faqs/${props.faq_id}`, { headers: { 'accept': 'application/json' } }).then((response) => {
         // console.log("response get faqs", response);
         setPagesItem(response.data.pages)
      });
   }

   useEffect(() => {
      getParent();
   }, [props]);

   // console.log("catItem для faq", catItem)

   // Заповнити сторінки, які додані до faq, записані у форматі PUT (`api/faqs/id`) для відправлення
   useEffect(() => {
      if (pagesItem.length > 0) {
         let oldPages = [];
         // Наповнити масив з категорями, перетвеними у формат для API
         pagesItem.map(el => oldPages.push(`api/pages/${el.id}`));
         setOldPages(oldPages);
      }
      else {
         setOldPages([]);
      }
   }, [pagesItem]);

   // Додати нову сторінку
   const handleSave = () => {
      // Перевірка, чи вибрана сторінка вже належить до даного faq
      let enters = pagesItem.length > 0 ? pagesItem.some(el => el.id === selectedOption.value) : false;
      if (enters) {
         // Popup про неуспішні зміни
         props.toastifyWarning(popupTextWarning);
      } else {
         // Вибрана нова сторінка
         let newPages = [`api/pages/${selectedOption.value}`];
         // Об'єднати старі категорії (якщо є) і нову категорію
         let pages = oldPages.length > 0 ? oldPages.concat(newPages) : newPages;
         // console.log('pages', pages);
         // Дані, які підуть із запитом
         let article = {
            pages: pages
         };
         console.log('article', article)

         // Оновити сторінки для faq
         AxiosInstance.put(`/faqs/${props.faq_id}`, article).then((response) => {
            // AxiosInstance.put(`/faqs/${props.faq_id}`, article, { headers: { 'accept': 'application/json' } }).then((response) => {
            // console.log("response put", response);
            if (response.status == 200) {
               // Popup про успішні зміни
               props.toastifySuccess(popupTextPutSuccess);
               getParent();
            }
         });
      };
   };

   // Видалити сторінку від faq
   const deletePage = (id) => {
      let pages = [];
      // Відфільтрувати категорію, яку потрібно видалити
      let filterPages = pagesItem.filter(el => el.id !== id);
      // Наповнити масив з сторінками, перетвеними у формат для API
      filterPages.map(el => pages.push(`api/pages/${el.id}`));
      // Дані, які підуть із запитом
      let article = {
         pages: pages
      };

      // Оновити сторінки для faq
      AxiosInstance.put(`/faqs/${props.faq_id}`, article).then((response) => {
         // console.log("response put", response);
         if (response.status == 200) {
            // Popup про успішні зміни
            props.toastifySuccess(popupTextDeleteSuccess);
            getParent();
         }
      });
   };

   // Видалити сторінку з faq
   function Deleted(row) {
      confirmAlert({
         title: 'Ви впевнені що хочите видалити цей пункт ?',
         message: 'Are you sure to do this.',
         buttons: [
            {
               label: 'Так',
               onClick: () => {
                  // console.log("delete row id", row);
                  deletePage(row);
               }
            },
            {
               label: 'Ні',
               onClick: () => {
                  return;
               }
            }
         ]
      });
   };
   // console.log('props', props)
   // console.log('pagesItem', pagesItem)
   // console.log('salectedOption', selectedOption)
   // console.log('oldPages', oldPages)

   return (
      <>
         <div className="row">
            <div className="col"><h3>Сторінки</h3></div>
            <div className="col d-flex">
               <AsyncSelect
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  value={selectedOption}
                  onChange={handleChange}
                  className="flex-grow-1 me-2"
               />
               <CButton onClick={handleSave} className="mb-2" color="secondary">+</CButton>
            </div>
         </div>

         {/* Список з доданими сторінками */}
         {
            (pagesItem.length > 0) ?
               <CListGroup className="mb-3">
                  {
                     pagesItem.map((v, k) => {
                        i++;
                        return (
                           <CListGroupItem key={k} className="d-flex justify-content-between align-items-center">
                              <Link to={`/site-pages/update/${v.id}`} >{`${i})`} {v.name}</Link>
                              {/* {`${i})`} {v.name} */}
                              <CButton color="danger" variant="outline" onClick={() => { Deleted(v.id) }}>
                                 Видалити
                              </CButton>
                           </CListGroupItem>
                        )
                     })
                  }
               </CListGroup>
               :
               <p className="ml-3">Сторінок не знайдено</p>
         }
      </>
   );
};

export default FaqsPages;